import React from 'react';
import { Container, Form, InputGroup, Label, Row } from 'reactstrap';
import { Field } from 'redux-form';
import { compact } from 'underscore';
import cx from 'classnames';

// components
import FirmTypeAhead from '../../../components/form/field/firm-typeahead';
import DesignationFilter from '../../../components/form/filter/designation-filter';
import LanguageFilter from '../../../components/form/filter/language-filter';
import BufferedInput from '../../../components/form/field/buffered-input';

// decorators
import fieldButtonDropdown from '../../../decorators/field-button-dropdown';

// modules
import BS from '../../../theme/Bootstrap';
import styles from '../../Containers.module.scss';

const DesignationDropdown = fieldButtonDropdown(DesignationFilter);
const LanguageDropdown = fieldButtonDropdown(LanguageFilter);

const RealtorSearch = props => {
  const { handleSubmit } = props;
  return (
    <Row className={cx(styles.searchHeader, BS.pt3)}>
      <Container>
        <Form inline className={BS.alignItemsStart} onSubmit={handleSubmit}>
          {props.children}
          <InputGroup className={cx(BS.inputGroupGutter, BS.pb2, BS.mrSm2)}>
            <Label for="name" className="sr-only">
              Name
            </Label>
            <Field
              name="name"
              type="text"
              placeholder="Name"
              component={BufferedInput}
              showSubmit
              submitClassName={cx(BS.ml2, BS.dMdNone)}
            />
          </InputGroup>
          <InputGroup className={cx(BS.inputGroupGutter, BS.pb2, BS.mrSm2)}>
            <Label for="firm" className="sr-only">
              Brokerage Name
            </Label>
            <Field
              name="firm"
              type="text"
              placeholder="Brokerage Name"
              component={FirmTypeAhead}
              officeType="brokerage"
              showSubmit
              submitClassName={cx(BS.ml2)}
            />
          </InputGroup>
          <InputGroup className={cx(BS.inputGroupGutter, BS.dNone, BS.dSmFlex, BS.pb2)}>
            <Field
              name="designation"
              format={value => {
                return compact((value || '').trim().split(','));
              }}
              normalize={value => {
                return value.join(',');
              }}
              component={DesignationDropdown}
              label="Designations"
              numCols={1}
              numInnerCols={1}
            />
            <Field
              name="language"
              format={value => {
                return compact((value || '').trim().split(','));
              }}
              normalize={value => {
                return value.join(',');
              }}
              component={LanguageDropdown}
              label="Language"
              numCols={2}
              numInnerCols={1}
            />
          </InputGroup>
        </Form>
      </Container>
    </Row>
  );
};

export default RealtorSearch;



// WEBPACK FOOTER //
// ./src/containers/AgentSearch/Search/RealtorSearch.js